import localForage from 'localforage';

export const setItem = async (key, value) => {
    return localForage.setItem(key, value);
};

export const getItem = async (key) => {
    return await localForage.getItem(key);
};

export const removeItem = async (key) => {
    return await localForage.removeItem(key);
};

export const clearAllItems = async () => {
    return await localForage.clear();
};
/* ---------- Session (tab-lifetime) ---------- */

export const setSessionItem = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionItem = (key) => {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};

export const removeSessionItem = (key) => {
    sessionStorage.removeItem(key);
};

export const clearSession = () => {
    sessionStorage.clear();
};